import { render, staticRenderFns } from "./ProviderInfo.vue?vue&type=template&id=38294d0c&scoped=true&"
import script from "./ProviderInfo.vue?vue&type=script&lang=js&"
export * from "./ProviderInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProviderInfo.vue?vue&type=style&index=0&id=38294d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38294d0c",
  null
  
)

export default component.exports